import React, { ReactNode } from 'react';
import { TextInput } from './text-input';
import {
  OnValueChange,
  PatternFormat,
  patternFormatter,
} from 'react-number-format';

export const FormattedInput: React.FC<{
  type?: React.HTMLInputTypeAttribute;
  name?: string;
  placeholder?: string;
  leftIcon?: ReactNode;
  value?: number | string;
  format: string;
  disabled?: boolean;
  onValueChange?: OnValueChange;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  autoFocus?: boolean;
  valueIsNumericString?: boolean;
  className?: string;
}> = ({
  disabled,
  type,
  format,
  name,
  value,
  placeholder,
  leftIcon,
  onChange,
  onBlur,
  onValueChange,
  autoFocus,
  valueIsNumericString,
  className,
}) => {
  return (
    <>
      <PatternFormat
        autoFocus={autoFocus}
        disabled={disabled}
        onBlur={onBlur}
        onChange={onChange}
        onValueChange={onValueChange}
        value={value}
        type={undefined}
        customInput={TextInput}
        leftIcon={leftIcon}
        name={name}
        placeholder={placeholder}
        format={format}
        valueIsNumericString={valueIsNumericString}
        className={className}
      />
    </>
  );
};
